import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from "app/components/Input";
import { useState } from "react";
import Form from "app/components/Form";
import { BpayBillerHistoryDocument, useCreateBpayBillerMutation, TransferAccountsByPartyDocument, } from "generated/generated-models";
import { nameof } from "core/util/nameof";
import { Formik } from "formik";
import { Validate } from "./AddBpayBillerValidate";
import RequestMultiFactorTokenFormik from "app/components/RequestMultiFactorTokenFormik";
import { Alert, LoadingButton } from "@mui/lab";
import BpayText from "app/components/BpayText";
import { Box, Button } from "@mui/material";
import { useSafeArea } from "app/layout/Navbar/useSafeArea";
const AddBpayBiller = ({ handleClose, goBack = () => {
    return;
}, billerAdded = () => {
    return;
}, }) => {
    const [createBiller, { data, error }] = useCreateBpayBillerMutation();
    const initialValues = {
        billerDescription: "",
        billerCode: undefined,
        customerReferenceNumber: "",
    };
    const { insetTop } = useSafeArea();
    const [addBpayBillerPage, setAddBpayBillerPage] = useState("WithoutMFA");
    const handleRequiresMFA = () => {
        setAddBpayBillerPage("WithMFA");
    };
    const handleCancelClick = () => {
        goBack();
        handleClose();
    };
    const handleSubmit = async (values) => {
        const result = await createBiller({
            variables: {
                input: {
                    BillerCode: values.billerCode,
                    CustomerReferenceNumber: values.customerReferenceNumber,
                    BillerDescription: values.billerDescription,
                    TwoFactorToken: values.twoFactorToken,
                    HasPendingTransfer: false,
                },
            },
            refetchQueries: [
                { query: BpayBillerHistoryDocument },
                { query: TransferAccountsByPartyDocument },
            ],
        });
        if (result.data?.createBpayBiller?.Code === "499") {
            handleRequiresMFA();
        }
        if (result.data?.createBpayBiller?.NewBpayBiller != null) {
            billerAdded(result.data.createBpayBiller.NewBpayBiller);
            handleClose();
        }
    };
    return (_jsx(Formik, { initialValues: initialValues, onSubmit: (values) => handleSubmit(values), validationSchema: () => Validate(addBpayBillerPage === "WithMFA"), children: ({ isSubmitting }) => {
            return (_jsxs("div", { children: [_jsx(Box, { sx: { height: insetTop } }), _jsxs("h2", { children: ["Add ", _jsx(BpayText, {}), " Biller"] }), _jsxs(Form, { children: [_jsx(Input, { name: nameof("billerCode"), type: "wholeNumber", label: "Biller Code" }), _jsx(Input, { name: nameof("customerReferenceNumber"), type: "text", label: "Customer Reference Number" }), _jsx(Input, { name: nameof("billerDescription"), type: "text", label: "Biller Nickname" }), addBpayBillerPage === "WithMFA" && (_jsx(RequestMultiFactorTokenFormik, { name: nameof("twoFactorToken"), showRequestNewToken: true, requestMfaOnDisplay: true })), data?.createBpayBiller?.Message != null && (_jsx(Alert, { severity: "error", children: data?.createBpayBiller.Message })), error != null && (_jsx(Alert, { severity: "error", children: "Error submitting new biller request. Please try again" })), _jsxs("div", { className: "button-row", children: [_jsx(Button, { className: "btn-cancel", id: "cancel", sx: { p: 1.5, mt: 1 }, variant: "contained", onClick: handleCancelClick, disabled: isSubmitting, children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { p: 1.5, mt: 1 }, loading: isSubmitting, loadingPosition: "end", variant: "contained", children: "Create Biller" })] })] })] }));
        } }));
};
export default AddBpayBiller;
